import React, {
  useCallback, useMemo, useState,
} from 'react';
import { TableContainer } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';
import PeriodField from '../../components/UI/Field/Period/PeriodField';
import { ButtonPesquisar } from '../ContaCorrenteCliente/V2/ContaCorrenteCliente/contaCorrenteClienteStyles';
import useStyle, {
  CardInfo,
  CardTop,
  HeadContainer, RootContainer,
  TabelaContainer,
} from './NotasFiscaisPageStyles';
import TabelaNotasFiscais from './TableNotasFiscais/TabelaNotasFiscais';
import { tableNotasFiscaisFactory } from './TableNotasFiscais/NotasFiscaisFactory';
import WrapperSubTitleForm from '../../components/UI/WrapperSubTitleForm';
import OptionDialogNew from '../../components/UI/Dialogs/OptionDialog/OptionDialogNew';
import { CNPJ_MASK, CPF_MASK } from '../../helpers/constants/layout.constants';
import { changeKeyHandler, KEY_TEXT } from '../../helpers/utils/changeEvents.utils';
import { toAmericanDate } from '../../helpers/utils/utils';
import MaskField from '../../components/UI/Field/Mask/MaskField';
import { ButtonUI, InputField } from '../../components';
import ChooseField from '../../components/UI/Field/Choose/ChooseField';
import RadioField from '../../components/UI/Field/Radio/RadioField';
import {
  buscarDadosTabelaAction,
  exportarNotasFiscaisAction,
  cancelarNotaFiscalAction,
  visualizarNotaFiscalClienteAction,
  downloadProtocoloCancelamentoNFAction,
} from '../../store/NotasFiscais/NotasFiscais.saga';
import { useNotasFiscaisDispatch, useNotasFiscaisSelector } from '../../store/NotasFiscais/NotasFiscaisProvider';
import { setSimpleNotasFiscaisAction } from '../../store/NotasFiscais/NotasFiscais.store';
import Grid24 from '../../components/UI/Grid24';
import { HrColored } from '../ContaCorrenteHonorario/ContaCorrenteHonorarioStyles';

function NotasFiscaisComponent() {
  const notasFiscaisDispatch = useNotasFiscaisDispatch();

  const style = useStyle();
  const hoje = useMemo(() => new Date(), []);

  const permissoesUsuario = useSelector(states => (states.authentication.userInformation
    ? states.authentication.userInformation.permissoes
    : []));

  const [openDialogCancelNotaFiscal, setOpenDialogCancelNotaFiscal] = useState(false);
  const [idNotaFiscalClienteSelecionado, setIdNotaFiscalClienteSelecionado] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);

  const filtrosRequest = useNotasFiscaisSelector(states => states.filtrosRequest || {});
  const periodoInicialStore = useNotasFiscaisSelector(states => states.periodoInicial || {});
  const periodoFinalStore = useNotasFiscaisSelector(states => states.periodoFinal || {});
  const page = useNotasFiscaisSelector(states => states.page ?? 0);
  const rowsPerPage = useNotasFiscaisSelector(states => states.rowsPerPage ?? 10);
  const arrowOrdenacao = useNotasFiscaisSelector(states => states.arrowDirection ?? true);
  const columnOrdenacao = useNotasFiscaisSelector(states => states.columnOrdenacao || { element: 'dataNota', order: 'DESC' });
  const notasFiscais = useNotasFiscaisSelector(states => states.tableView || []);
  const totalElements = useNotasFiscaisSelector(states => states.totalElements || 0);
  const resumoNotasFiscais = useNotasFiscaisSelector(states => states.resumoNotasFiscais || {
    ativaCliente: 0,
    canceladaCliente: 0,
    foraPrazoCliente: 0,
    ativaDevedor: 0,
    canceladaDevedor: 0,
    foraPrazoDevedor: 0,
  });

  const periodoInicial = useMemo(() => ({
    name: 'periodoInicial',
    maxDate: hoje,
    ...periodoInicialStore,
  }), [hoje, periodoInicialStore]);

  const periodoFinal = useMemo(() => ({
    name: 'periodoFinal',
    maxDate: hoje,
    ...periodoFinalStore,
  }), [hoje, periodoFinalStore]);

  const documentFormat = useMemo(
    () => ((filtrosRequest.cpfCnpj || '').length <= 11 ? CPF_MASK : CNPJ_MASK),
    [filtrosRequest.cpfCnpj],
  );

  const permissoes = useMemo(() => ({
    prestarContas: permissoesUsuario?.includes('ROLE_1804'),
  }), [permissoesUsuario]);

  const onChangePeriodoHandler = (event) => {
    const { name, value } = event.target;
    const fieldValue = name === 'periodoInicial' ? periodoInicialStore : periodoFinalStore;
    notasFiscaisDispatch(setSimpleNotasFiscaisAction(name, {
      ...fieldValue,
      value,
    }));
  };

  const changeDocumentoStringKey = useCallback((e) => {
    changeKeyHandler(e, KEY_TEXT);
    const { value } = e.target;
    notasFiscaisDispatch(setSimpleNotasFiscaisAction('filtrosRequest', {
      ...filtrosRequest,
      cpfCnpj: value,
    }));
  }, [notasFiscaisDispatch, filtrosRequest]);

  const onChangeHandler = useCallback((e) => {
    const { name, value } = e.target;
    notasFiscaisDispatch(setSimpleNotasFiscaisAction('filtrosRequest', {
      ...filtrosRequest,
      [name]: value,
    }));
  }, [notasFiscaisDispatch, filtrosRequest]);

  const handleCancelNotaFiscais = useCallback((idNotaFiscalCliente) => {
    setOpenDialogCancelNotaFiscal(true);
    setIdNotaFiscalClienteSelecionado(idNotaFiscalCliente);
  }, []);

  const handleOnClickCancel = useCallback(() => {
    setOpenDialogCancelNotaFiscal(false);
  }, []);

  const handleCancelarNotasFiscais = useCallback(() => {
    if (!idNotaFiscalClienteSelecionado) {
      setOpenDialogCancelNotaFiscal(false);
      return;
    }

    notasFiscaisDispatch(cancelarNotaFiscalAction(idNotaFiscalClienteSelecionado));
    setOpenDialogCancelNotaFiscal(false);
    setIdNotaFiscalClienteSelecionado(null);
  }, [idNotaFiscalClienteSelecionado, notasFiscaisDispatch]);

  const visualizarNotaFiscalCliente = useCallback((urlPrefeituraNF) => {
    notasFiscaisDispatch(visualizarNotaFiscalClienteAction(urlPrefeituraNF));
  }, [notasFiscaisDispatch]);

  const downloadProtocoloCancelamentoNF = useCallback((idNotaFiscalCliente) => {
    notasFiscaisDispatch(downloadProtocoloCancelamentoNFAction(idNotaFiscalCliente));
  }, [notasFiscaisDispatch]);

  const setArrowOrdenacao = useCallback((valueOrUpdater) => {
    const nextValue = typeof valueOrUpdater === 'function'
      ? valueOrUpdater(arrowOrdenacao)
      : valueOrUpdater;

    notasFiscaisDispatch(setSimpleNotasFiscaisAction('arrowDirection', nextValue));
  }, [notasFiscaisDispatch, arrowOrdenacao]);

  const setColumnOrdenacao = useCallback((value) => {
    notasFiscaisDispatch(setSimpleNotasFiscaisAction('columnOrdenacao', value));
    if (hasSearched) {
      notasFiscaisDispatch(setSimpleNotasFiscaisAction('page', 0));
      notasFiscaisDispatch(buscarDadosTabelaAction());
    }
  }, [notasFiscaisDispatch, hasSearched]);

  const tableColumns = useMemo(
    () => tableNotasFiscaisFactory.makeCabecalhoTabela({
      arrowOrdenacao,
      columnOrdenacao,
      setArrowOrdenacao,
      setColumnOrdenacao,
    }),
    [arrowOrdenacao, columnOrdenacao, setArrowOrdenacao, setColumnOrdenacao],
  );

  const tableRows = useMemo(() => tableNotasFiscaisFactory.makeConteudoTabela(
    notasFiscais,
    permissoes,
    handleCancelNotaFiscais,
    visualizarNotaFiscalCliente,
    downloadProtocoloCancelamentoNF,
  ), [
    notasFiscais,
    permissoes,
    handleCancelNotaFiscais,
    visualizarNotaFiscalCliente,
    downloadProtocoloCancelamentoNF,
  ]);

  const isSearchDisabled = useMemo(() => {
    const temCpfCnpj = !!filtrosRequest.cpfCnpj?.trim();
    const temRPS = !!filtrosRequest.numeroRPSNotaFiscal?.trim();
    const temNome = !!filtrosRequest.nome?.trim();
    const temProcesso = !!filtrosRequest.numeroProcesso?.trim();
    const temPeriodoInicial = !!periodoInicial.value?.trim();
    const temPeriodoFinal = !!periodoFinal.value?.trim();
    return !(temCpfCnpj || temRPS || temNome || temProcesso || temPeriodoInicial || temPeriodoFinal);
  }, [filtrosRequest, periodoInicial.value, periodoFinal.value]);

  const periodoFinalComRestricao = useMemo(() => ({
    ...periodoFinal,
    minDate: periodoInicial.value ? toAmericanDate(periodoInicial.value) : undefined,
  }), [periodoFinal, periodoInicial.value]);

  const executarBuscaTabela = useCallback(() => {
    notasFiscaisDispatch(buscarDadosTabelaAction());
  }, [notasFiscaisDispatch]);

  const changePageHandler = useCallback((event, newPage) => {
    notasFiscaisDispatch(setSimpleNotasFiscaisAction('page', newPage));
    if (!hasSearched) {
      return;
    }

    executarBuscaTabela();
  }, [notasFiscaisDispatch, hasSearched, executarBuscaTabela]);

  const changeRowsPerPageHandler = useCallback((event) => {
    const newRowsPerPage = Number(event.target.value);
    notasFiscaisDispatch(setSimpleNotasFiscaisAction('rowsPerPage', newRowsPerPage));
    notasFiscaisDispatch(setSimpleNotasFiscaisAction('page', 0));
    if (!hasSearched) {
      return;
    }

    executarBuscaTabela();
  }, [notasFiscaisDispatch, hasSearched, executarBuscaTabela]);

  const handlePesquisar = useCallback(() => {
    setHasSearched(true);
    notasFiscaisDispatch(setSimpleNotasFiscaisAction('page', 0));
    executarBuscaTabela();
  }, [notasFiscaisDispatch, executarBuscaTabela]);

  const handleDownloadExcel = useCallback(() => {
    notasFiscaisDispatch(exportarNotasFiscaisAction());
  }, [notasFiscaisDispatch]);

  return (
    <RootContainer>
      <OptionDialogNew
        open={openDialogCancelNotaFiscal}
        confirmLabel="Confirmar"
        cancelLabel="Cancelar"
        onClickCancel={handleOnClickCancel}
        onClickConfirm={handleCancelarNotasFiscais}
        text=" Deseja realmente cancelar esta Nota Fiscal?"
      />
      <HeadContainer>
        <Grid24 container isFormContainer spacing="1" style={{ marginBottom: '16px' }}>
          <Grid24 item xs={24} sm={14}>
            <Grid24 container spacing="1">
              <Grid24 item xs={24} sm={24}>
                <PeriodField
                  label="Data da Emissão:"
                  firstField={periodoInicial}
                  lastField={periodoFinalComRestricao}
                  onChange={onChangePeriodoHandler}
                />
              </Grid24>
              <Grid24 item xs={24} sm={24} style={{ marginTop: '10px' }}>
                <div style={{ justifyContent: 'space-between', display: 'flex', width: '100%' }}>
                  <Grid24 xs={24} sm={12}>
                    <MaskField
                      fullWidth
                      label="CPF/CNPJ"
                      name="cpfCnpj"
                      value={filtrosRequest.cpfCnpj}
                      onChange={changeDocumentoStringKey}
                      format={
                        documentFormat === CPF_MASK
                          ? `${documentFormat}#`
                          : documentFormat
                      }
                    />
                  </Grid24>
                  <Grid24 xs={24} sm={10}>
                    <InputField
                      label="Nº NFe/ RPS"
                      name="numeroRPSNotaFiscal"
                      value={filtrosRequest.numeroRPSNotaFiscal}
                      maxLength={168}
                      onChange={onChangeHandler}
                    />
                  </Grid24>
                </div>
              </Grid24>
              <Grid24 item xs={24} sm={24} style={{ marginTop: '10px' }}>
                <InputField
                  fullWidth
                  label="Nome"
                  name="nome"
                  value={filtrosRequest.nome}
                  maxLength={168}
                  onChange={onChangeHandler}
                />
              </Grid24>
              <Grid24 item xs={24} sm={24} style={{ marginTop: '10px' }}>
                <InputField
                  fullWidth
                  label="Número do processo"
                  name="numeroProcesso"
                  value={filtrosRequest.numeroProcesso}
                  maxLength={168}
                  onChange={onChangeHandler}
                />
              </Grid24>
            </Grid24>
          </Grid24>
          <Grid24 item xs={24} sm={4}>
            <ButtonPesquisar type="button" onClick={handlePesquisar} disabled={isSearchDisabled}>
              <SearchIcon />
            </ButtonPesquisar>
          </Grid24>
          <Grid24 item xs={24} sm={24} style={{ marginTop: '10px' }}>
            <ChooseField
              aria-label="status-nota-fiscal"
              label="Status da nota fiscal"
              name="statusNotaFiscal"
              value={filtrosRequest.statusNotaFiscal}
              onChange={onChangeHandler}
            >
              <RadioField label="Todas" value="todosStatus" />
              <RadioField label="Ativas" value="ativa" />
              <RadioField label="Canceladas" value="cancelada" />
            </ChooseField>
            <ChooseField
              aria-label="tipo-fiscal"
              label="Tipo da nota fiscal"
              name="tipoNotaFiscal"
              value={filtrosRequest.tipoNotaFiscal}
              onChange={onChangeHandler}
            >
              <RadioField label="Todas" value="todosTipos" />
              <RadioField label="Cliente" value="cliente" />
              <RadioField label="Devedor" value="devedor" />
            </ChooseField>
          </Grid24>
        </Grid24>
        <Grid24 container isFormContainer spacing="1" style={{ marginBottom: '16px' }}>
          <WrapperSubTitleForm title="Resumo" className={style.headerResumo} />
          <Grid24
            item
            xs={24}
            sm={12}
            style={{ height: 'fit-content' }}
          >
            <CardTop color="#58a9f0">
              <CardInfo>
                <p>Notas fiscais devedores</p>
                <HrColored color="#3878b4" />
                <p>
                  Ativas
                  {' '}
                  <span>
                    {
                      resumoNotasFiscais.ativaDevedor
                    }
                  </span>
                </p>
                <HrColored color="#3878b4" />
                <p>
                  Canceladas
                  {' '}
                  <span>
                    {
                      resumoNotasFiscais.canceladaDevedor
                    }
                  </span>
                </p>
                <HrColored color="#3878b4" />
                <p>
                  Canceladas fora do prazo
                  {' '}
                  <span>
                    {
                      resumoNotasFiscais.foraPrazoDevedor
                    }
                  </span>
                </p>
              </CardInfo>
            </CardTop>
          </Grid24>
          <Grid24
            item
            xs={24}
            sm={12}
            style={{ height: 'fit-content' }}
          >
            <CardTop color="#3373eb">
              <CardInfo>
                <p>Notas fiscais clientes</p>
                <HrColored color="#205ac0" />
                <p>
                  Ativas
                  {' '}
                  <span>
                    {
                      resumoNotasFiscais.ativaCliente
                    }
                  </span>
                </p>
                <HrColored color="#205ac0" />
                <p>
                  Canceladas
                  {' '}
                  <span>
                    {
                      resumoNotasFiscais.canceladaCliente
                    }
                  </span>
                </p>
                <HrColored color="#205ac0" />
                <p>
                  Canceladas fora do prazo
                  {' '}
                  <span>
                    {
                      resumoNotasFiscais.foraPrazoCliente
                    }
                  </span>
                </p>

              </CardInfo>
            </CardTop>
          </Grid24>
        </Grid24>
      </HeadContainer>
      <TabelaContainer>
        <ButtonUI
          style={{ width: '100px', alignSelf: 'flex-end', marginRight: '16px' }}
          color="white"
          onClick={handleDownloadExcel}
          disabled={notasFiscais.length === 0}
        >
          Excel
        </ButtonUI>
        <TableContainer>
          <TabelaNotasFiscais
            columns={tableColumns}
            rows={tableRows}
            page={page}
            rowsPerPage={rowsPerPage}
            size={totalElements}
            rowsPerPageOptions={[10, 15, 20]}
            onChangePage={changePageHandler}
            onChangeRowsPerPage={changeRowsPerPageHandler}
          />
        </TableContainer>
      </TabelaContainer>
    </RootContainer>
  );
}

export const NotasFiscais = withRouter(NotasFiscaisComponent);
